(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaSnomedDialogController', RcopiaSnomedDialogController);

    RcopiaSnomedDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RcopiaSnomed'];

    function RcopiaSnomedDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RcopiaSnomed) {
        var vm = this;

        vm.rcopiaSnomed = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rcopiaSnomed.id !== null) {
                RcopiaSnomed.update(vm.rcopiaSnomed, onSaveSuccess, onSaveError);
            } else {
                RcopiaSnomed.save(vm.rcopiaSnomed, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:rcopiaSnomedUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
